/**
 * La coda di salvataggio riga per riga (`coda.ts`) dentro una vista React:
 * una coda per tutta la vita della vista, che nasce con i valori letti, si
 * chiude allo smontaggio e avvisa prima di lasciare la pagina finche ci sono
 * righe in sospeso. La usano appello (V14), voti (V15, V27) e log della seduta (V67).
 */

import { useEffect, useReducer, useState } from 'react';
import { CodaRighe, type Voluto } from './coda.js';

export function useCodaRighe<V extends string | number>(
  iniziali: () => Record<string, Voluto<V>>,
  invia: (giocatoreId: string, valore: Voluto<V>) => Promise<void>,
  onRifiuto: (messaggio: string) => void,
): CodaRighe<V> {
  const [, aggiorna] = useReducer((n: number) => n + 1, 0);
  const [c] = useState(
    () =>
      new CodaRighe<V>(iniziali(), invia, ({ rifiuto }) => {
        if (rifiuto) onRifiuto(rifiuto);
        aggiorna();
      }),
  );

  useEffect(() => () => c.chiudi(), [c]);

  useEffect(() => {
    const avvisaUscita = (e: BeforeUnloadEvent) => {
      if (c.inSospeso() > 0) e.preventDefault();
    };
    window.addEventListener('beforeunload', avvisaUscita);
    return () => window.removeEventListener('beforeunload', avvisaUscita);
  }, [c]);

  return c;
}
